export default __webpack_public_path__ + "static/media/hello-light.5d44f5f5.png";